import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/ChatMgButton.png';
const _hoisted_1 = { class: "simplePage" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "toggle-row" };
const _hoisted_4 = { class: "toggle-row" };
const _hoisted_5 = { class: "" };
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useApi } from '@/composables/useApi';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import MGToggle from './elements/MGToggle.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnableNotificationsPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer, savePreferences } = useCustomer();
        const { signalV1 } = useApi();
        function onLoad() {
            getCustomer(() => {
                if (state.customer && state.customer.preferences == null) {
                    state.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false };
                }
            });
        }
        function enableNotifications() {
            localStorage.setItem("notificationsRequested", "true");
            signalV1("enableNotifications", "", "", "", "personalisation");
        }
        function savePrefs() {
            savePreferences(() => {
                if (state.customer && state.customer.preferences == null) {
                    state.customer.preferences = { dailyCurrentBalanceNotifications: false, dailyCreditBalanceNotifications: false };
                }
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            _cache[6] || (_cache[6] = _createElementVNode("h1", null, "Notifications", -1)),
                            _cache[7] || (_cache[7] = _createElementVNode("p", null, "Receive personalised notifications which can save you time and money.", -1)),
                            _cache[8] || (_cache[8] = _createElementVNode("img", { src: _imports_0 }, null, -1)),
                            (_unref(state).customer)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    _cache[5] || (_cache[5] = _createElementVNode("p", null, "As well as notifications generated when we spot something that could be important to you, you can enable daily balance notifications to help you monitor your spending.", -1)),
                                    _createElementVNode("div", _hoisted_3, [
                                        _cache[3] || (_cache[3] = _createElementVNode("span", null, "Also send daily current balance", -1)),
                                        _createVNode(MGToggle, {
                                            modelValue: _unref(state).customer.preferences.dailyCurrentBalanceNotifications,
                                            "onUpdate:modelValue": [
                                                _cache[0] || (_cache[0] = ($event) => ((_unref(state).customer.preferences.dailyCurrentBalanceNotifications) = $event)),
                                                savePrefs
                                            ]
                                        }, null, 8, ["modelValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_4, [
                                        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Also send daily credit balance", -1)),
                                        _createVNode(MGToggle, {
                                            modelValue: _unref(state).customer.preferences.dailyCreditBalanceNotifications,
                                            "onUpdate:modelValue": [
                                                _cache[1] || (_cache[1] = ($event) => ((_unref(state).customer.preferences.dailyCreditBalanceNotifications) = $event)),
                                                savePrefs
                                            ]
                                        }, null, 8, ["modelValue"])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(MGButton, {
                                    text: "Enable",
                                    onClick: enableNotifications
                                }),
                                _createElementVNode("div", {
                                    class: "mt-3",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (_unref(router).push('/personalisation')))
                                }, "No thanks. Skip for now")
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("div", {
                                class: "",
                                style: { "clear": "both", "padding-bottom": "50px" }
                            }, null, -1))
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
